
<template>
<section class="payment-details">
  <div>
    <div class="columns">
      <div class="col">
        <dl>
          <dt class="data-label">Check Amount</dt>
          <dd class="data-content"> {{ check_amount }} </dd>
        </dl>
        <dl>
          <dt class="data-label">Check Number</dt>
          <dd class="data-content"> {{ check_number }} </dd>
        </dl>
        <dl>
          <dt class="data-label">Check Date</dt>
          <dd class="data-content"> {{ check_date }} </dd>
        </dl>
        <a @click="downloadPaymentCSV()"><span><i class="far fa-file-excel"></i></span> Download CSV</a>
        <div v-if="charityId" class="table-no-search">
          <datatable
            :source='charityProceeds'
            :filterable="false"
            :isLoading='isLoading'>
            <datatable-column
              v-for='(column, index) in charityColumns'
              :id='column.id'
              :label='column.label'
              :key='index'
              >
            </datatable-column>
            <template slot="searchLeft">
            </template>
            <template slot="source_template" slot-scope="data">
              <tr>
                <td>{{ data.row.ref_number }}</td>
                <td>{{ data.row.vehicle }}</td>
                <td>{{ data.row.donor }}</td>
                <td>{{ data.row.sale_price }}</td>
                <td>{{ data.row.auction_fee }}</td>
                <td>{{ data.row.conditioning_fee }}</td>
                <td>{{ data.row.processing_fee }}</td>
                <td>{{ data.row.repair_cost }}</td>
                <td>{{ data.row.tow_expense }}</td>
                <td>{{ data.row.gross_proceeds }}</td>
                <td>{{ data.row.charity_proceeds }}</td>
              </tr>
            </template>
            <template slot="tfoot" slot-scope="data">
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>TOTAL PAID</td>
                <td>{{ check_amount }}</td>
              </tr>
            </template>
          </datatable>
        </div>
        <div v-if="towingCompanyId" class="table-no-search">
          <datatable
            :source='towingCompanyProceeds'
            :filterable="false"
            :isLoading='isLoading'>
            <datatable-column
              v-for='(column, index) in towingColumns'
              :id='column.id'
              :label='column.label'
              :key='index'
              >
            </datatable-column>
            <template slot="searchLeft">
            </template>
            <template slot="source_template" slot-scope="data">
              <tr>
                <td>{{ data.row.ref_number }}</td>
                <td>{{ data.row.tow_date }}</td>
                <td>{{ data.row.vehicle }}</td>
                <td>{{ data.row.pickup_location }}</td>
                <td>{{ data.row.destination }}</td>
                <td>{{ data.row.towing_fee }}</td>
              </tr>
            </template>
            <template slot="tfoot" slot-scope="data">
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>TOTAL PAID</td>
                <td>{{ check_amount }}</td>
              </tr>
            </template>
          </datatable>
        </div>
      </div>
    </div>
  </div>
</section>
</template>

<script>
import store from '@/store'
import helpers from '@/helpers'
import Datatable from '@/components/Datatables/AppDatatable'
import DatatableColumn from '@/components/Datatables/AppDatatableColumn'

export default {
  name: 'PaymentDetails',
  mounted () {
    this.refresh()
  },
  data () {
    return {
      check_number: null,
      check_date: null,
      check_amount: null,
      total_paid: null,

      charityColumns: [
        { id: 'ref_number', label: 'Ref #' },
        { id: 'vehicle', label: 'Vehicle' },
        { id: 'donor', label: 'Donor Name' },
        { id: 'sale_price', label: 'Sale Price' },
        { id: 'auction_fee', label: 'Auction Fee' },
        { id: 'conditioning_fee', label: 'Miscellaneous Fee' },
        { id: 'processing_fee', label: 'Processing Fee' },
        { id: 'repair_cost', label: 'Repair Cost' },
        { id: 'tow_expense', label: 'Tow & Expense' },
        { id: 'gross_proceeds', label: 'Adj. Gross Proceeds' },
        { id: 'charity_proceeds', label: 'Charity Proceeds' }
      ],
      towingColumns: [
        { id: 'ref_number', label: 'Ref #' },
        { id: 'tow_date', label: 'Tow Date' },
        { id: 'vehicle', label: 'Vehicle' },
        { id: 'pickup_location', label: 'Pickup Location' },
        { id: 'destination', label: 'Destination' },
        { id: 'towing_fee', label: 'Towing Fee' }
      ],
      charityProceeds: [],
      towingCompanyProceeds: [],
      isLoading: false
    }
  },
  props: ['charityId', 'towingCompanyId', 'paymentId'],
  methods: {
    refresh () {
      if (this.charityId) {
        this.isLoading = true
        Promise.all([
          store.functions.charity.getPaymentDetail(this.paymentId,
            (response) => {
              this.charityProceeds = response.data.vehicles
              this.total_paid = response.data.total
              this.check_amount = response.data.check_amount
              this.check_date = response.data.check_date
              this.check_number = response.data.check_number
            }
          ),
        ]).then(() => {
          this.isLoading = false
        })
      }
      if (this.towingCompanyId) {
        this.isLoading = true
        Promise.all([
          store.functions.towingCompanies.getPaymentDetail(this.paymentId,
            (response) => {
              this.towingCompanyProceeds = response.data.vehicles
              this.total_paid = response.data.total
              this.check_amount = response.data.check_amount
              this.check_date = response.data.check_date
              this.check_number = response.data.check_number
            }
          )
        ]).then(() => {
          this.isLoading = false
        })
      }
    },
    downloadPaymentCSV () {
      if (this.charityId) {
        store.functions.charity.downloadPaymentCSV({id: this.paymentId})
          .catch((error) => console.log(error))
          .then((response) => {
            helpers.openAsDownload(response.data, 'charity_payments_' + (new Date()).toJSON() + '.csv')
          })
      }
      if (this.towingCompanyId) {
        store.functions.towingCompanies.downloadPaymentCSV({id: this.paymentId})
          .catch((error) => console.log(error))
          .then((response) => {
            helpers.openAsDownload(response.data, 'towing_payments_' + (new Date()).toJSON() + '.csv')
          })
      }
    }
  },
  computed: {
    tableData () {
      if (this.charityId) return this.charityProceeds
      if (this.towingCompanyId) return this.towingCompanyProceeds
    },
  },
  components: {
    Datatable,
    DatatableColumn
  }
}
</script>

<style scoped>
  td.table-checkbox, td.table-checkbox * {
    width: 25px;
  }

</style>



// WEBPACK FOOTER //
// src/components/Payables/PaymentDetails.vue